module.exports = __webpack_public_path__ + "bffbecd3ac653c40b959fd1eff6c7513.png";